<!DOCTYPE html>
<html lang="es">
  <head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
  </head>
  <body>
    <header id="headContent">
      <span class="header-title">
        <span *ngIf="selectedDesk">
          {{ selectedDesk?.name }}
        </span>
        <span *ngIf="selectedLocation">
          {{ selectedLocation?.name }} {{ selectedLocation?.numeration }}
        </span>
      </span>

      <div class="header-controls">
        <button *ngIf="selectedLocation && currentWaitingAndAttendingTurns > 0 && !selectedLocationClosed" class="action-button yellow-button" (click)="showPendingTurns()">
          <span class="button-text">{{ 'advance.show turns' | translate }}</span>
        </button>
        <button *ngIf="selectedLocation && !selectedLocationClosed" class="action-button red-button"
                (click)="closeLocation()">
          <span class="button-text">{{ 'advance.close location' | translate }}</span>
        </button>
        <button *ngIf="selectedLocation && selectedLocationClosed" class="action-button green-button"
                (click)="openLocation()">
          <span class="button-text">{{ 'advance.open location' | translate }}</span>
        </button>
        <img src="/assets/images/settings.svg" class="settings-icon" alt="Settings" (click)="goToAdmin()">
      </div>
    </header>

    <main [style.display]="selectedDesk || (selectedLocation && !selectedLocationClosed) ? 'flex' : 'none'">
      <div id="turnContainer">
        <div id="turnDeskName" class="content_center">
          <div> {{ currentDeskName }} </div>
        </div>
        <div id="turnAttending" class="content_center">
          <div *ngIf="currentTurn && currentTurn != 'null'">
            {{ currentTurn }}
          </div>
          <div *ngIf="!currentTurn || currentTurn == 'null'">-</div>
        </div>
      </div>
      <div id="buttons" class="content_center">
        <button class="action-button yellow-button" (click)="callbackTurn()">
          <span class="button-text">{{ 'advance.recall' | translate }}</span>
        </button>
        <button class="action-button yellow-button" *ngIf="selectedLocation" (click)="requeueTurn()">
          <span class="button-text">{{ 'advance.pending' | translate }}</span>
        </button>
      </div>
      <div id="peopleWaiting" class="content_center">
        <div class="waiting-info content_center">
          <img src="/assets/images/people.png" height="80%" alt="Logo">
          <div> {{ currentWaitingAndAttendingTurns }} {{ 'advance.pending' | translate }}</div>
        </div>
      </div>
      <div id="mTurnTicketNext" (click)="callNextTurn()">
        <div matRipple [matRippleColor]="'#00000060'" style="position: absolute; width: 100%; height: 100%"></div>
        <div>
          <div class="row">
            <div class="content_center">
              <img id="logo" src="/assets/images/hand.png" width="10%" alt="Logo">
            </div>
          </div>
          <div class="content_center">
            <strong>{{ 'advance.advance' | translate }}</strong>
          </div>
        </div>
      </div>
    </main>
    <main [style.display]="(!selectedDesk && !selectedLocation) || (selectedLocation && selectedLocationClosed) ? 'flex' : 'none'">
      <div id="missingConfig" class="content_center">
        <span [style.display]="!selectedDesk && !selectedLocation ? 'block' : 'none'">
          {{ 'advance.error no selection' | translate }}
        </span>
        <span [style.display]="selectedLocation && selectedLocationClosed ? 'block' : 'none'">
          {{ 'advance.error open location' | translate }}
        </span>
      </div>
    </main>
    <footer id="footer" class="content_left">
      Power by <img src="/assets/images/mturn_logo.svg" class="footer-logo" alt="mTurn Logo">
    </footer>
    <h5>v{{ version }}</h5>
  </body>
</html>
